var map = {
	"./Complete Hiragana Practice Tracing Sheet.png": 61241,
	"./Complete Hiragana Practice Writing Sheet (Blank).png": 12332,
	"./Complete Hiragana Stroke Order Practice Tracing Sheet.png": 72469,
	"./Complete Katakana Practice Tracing Sheet.png": 65852,
	"./Complete Katakana Practice Writing Sheet (Blank).png": 51721,
	"./Complete Katakana Stroke Order Practice Tracing Sheet.png": 38074,
	"./Hiragana Character Chart.png": 75991,
	"./Hiragana Katakana Kanji Blank Practice Sheet.png": 83695,
	"./Japanese Character Practice Writing Sheet (Blank).png": 90902,
	"./Katakana Character Chart.png": 40808,
	"./Vertical Writing 12_18 Grid.png": 47000,
	"./Vertical Writing 18_12 Grid.png": 84892,
	"./Vertical Writing 9_6 Grid With Dashed Guides.png": 26685,
	"./Vertical Writing Sheet 6_9 Squares With Dashed Guides.png": 61166,
	"./boil.png": 35697,
	"./drawing.png": 61913,
	"./eat.png": 20917,
	"./emimaru.png": 5773,
	"./emimaru_flying.png": 27951,
	"./glue.png": 11124,
	"./hanapin.png": 58112,
	"./hat.png": 89860,
	"./hiragana_a.png": 83390,
	"./hiragana_ba.png": 77720,
	"./hiragana_be.png": 52252,
	"./hiragana_bi.png": 90448,
	"./hiragana_bo.png": 63654,
	"./hiragana_bu.png": 2860,
	"./hiragana_chi.png": 64797,
	"./hiragana_da.png": 27442,
	"./hiragana_de.png": 25654,
	"./hiragana_di.png": 88186,
	"./hiragana_do.png": 44972,
	"./hiragana_du.png": 36390,
	"./hiragana_e.png": 11194,
	"./hiragana_fu.png": 79000,
	"./hiragana_ga.png": 55347,
	"./hiragana_ge.png": 72375,
	"./hiragana_gi.png": 75339,
	"./hiragana_go.png": 50557,
	"./hiragana_gu.png": 68583,
	"./hiragana_ha.png": 52566,
	"./hiragana_he.png": 61682,
	"./hiragana_hi.png": 46782,
	"./hiragana_ho.png": 19656,
	"./hiragana_i.png": 8022,
	"./hiragana_ji.png": 60328,
	"./hiragana_ka.png": 20023,
	"./hiragana_ke.png": 33139,
	"./hiragana_ki.png": 12335,
	"./hiragana_ko.png": 6361,
	"./hiragana_ku.png": 42691,
	"./hiragana_ma.png": 2209,
	"./hiragana_me.png": 37893,
	"./hiragana_mi.png": 51033,
	"./hiragana_mo.png": 31151,
	"./hiragana_mu.png": 66261,
	"./hiragana_n.png": 82281,
	"./hiragana_na.png": 10772,
	"./hiragana_ne.png": 46864,
	"./hiragana_ni.png": 39292,
	"./hiragana_no.png": 4778,
	"./hiragana_nu.png": 57280,
	"./hiragana_o.png": 27456,
	"./hiragana_pa.png": 96446,
	"./hiragana_pe.png": 64762,
	"./hiragana_pi.png": 2230,
	"./hiragana_po.png": 28000,
	"./hiragana_pu.png": 20138,
	"./hiragana_ra.png": 76904,
	"./hiragana_re.png": 53868,
	"./hiragana_ri.png": 71776,
	"./hiragana_ro.png": 9814,
	"./hiragana_ru.png": 53788,
	"./hiragana_sa.png": 52255,
	"./hiragana_se.png": 79259,
	"./hiragana_shi.png": 95181,
	"./hiragana_so.png": 67857,
	"./hiragana_su.png": 51915,
	"./hiragana_ta.png": 59938,
	"./hiragana_te.png": 82982,
	"./hiragana_to.png": 71580,
	"./hiragana_tsu.png": 63343,
	"./hiragana_u.png": 68010,
	"./hiragana_wa.png": 61283,
	"./hiragana_wo.png": 24333,
	"./hiragana_ya.png": 43661,
	"./hiragana_yo.png": 80611,
	"./hiragana_yu.png": 27609,
	"./hiragana_za.png": 23440,
	"./hiragana_ze.png": 87348,
	"./hiragana_zo.png": 40302,
	"./hiragana_zu.png": 31972,
	"./kid.png": 16543,
	"./mouth.png": 27066,
	"./origami.png": 12125,
	"./painting.png": 919,
	"./papers.png": 33914,
	"./pear.png": 3211,
	"./pencil-4.png": 88967,
	"./pencil.png": 56516,
	"./pointer.png": 23824,
	"./quiz.png": 23984,
	"./ride.png": 67325,
	"./shanghaisakura.png": 44351,
	"./so.png": 17485,
	"./star.png": 86035,
	"./strokeorder.png": 45319,
	"./tree.png": 38923,
	"./typing.png": 71034,
	"./video_sample.png": 87009,
	"./vocabulary.png": 3183,
	"./whale.png": 9940,
	"./worksheetexample.png": 81321,
	"./writing.png": 63723,
	"./【あいうえおかきくけこ】T2W5(1).png": 88849,
	"./【がぎぐげござじずぜぞ】T2W5(6).png": 89687,
	"./【さしすせそたちつてと】T2W5(2).png": 87888,
	"./【だぢづでどばびぶべぼ】T2W5(7).png": 82167,
	"./【なにぬねのははひふへほ】T2W5(3).png": 89782,
	"./【ぱぴぷぺぽ】T2W5(8).png": 2022,
	"./【まみむめもやゆよ】T2W5(4).png": 60083,
	"./【らりるれろわをん】T2W5(5).png": 98249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;